import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ResetPasswordPageContent } from '@com-delta-idp/mnx-login-ui';
import { LoginHelperUtils } from '../../../utils/login-helper.utils';
import { LoginModalContent } from '../../models/aem';
import { ResetPasswordHelperService } from '../reset-password/reset-password-helper.service';

@Injectable({
  providedIn: 'root'
})
export class CreatePasswordHelperService extends ResetPasswordHelperService {
  formGroup!: UntypedFormGroup;

  constructor(protected override loginHelperUtils: LoginHelperUtils) {
    super(loginHelperUtils);
  }

  getCreatePasswordPageContent(
    aemResponse: LoginModalContent
  ): ResetPasswordPageContent {
    const { createPassword, pageHeader, resetPassword } = aemResponse;

    return {
      ...createPassword,
      pageHeader: {
        ...pageHeader,
        headerTitle: createPassword.headerTitle,
        headerSubTitle: createPassword.headerSubTitle
      },
      forgotLogin: resetPassword.forgotLogin,
      buttonLabel: createPassword.nextDisplayView.button_modal,
      errors: this.getInitialErrorMessage(aemResponse.errors)
    };
  }
}
